import { tns } from '../../_scripts/plugins/tiny-slider/tiny-slider.js';
import DetectedBrowser from "../../_scripts/utils/detect-browser"

export default class Templates {

  constructor() {
    this.mediaList = document.querySelector('.template__list--media');
    this.mediaNav = document.querySelector('.template__nav');
    this.templateAll = document.querySelectorAll('.template');
  }

  _tinySlider() {
    return tns({
      autoWidth: true,
      slideBy: 'page',
      mouseDrag: true,
      container: this.mediaList,
      controlsContainer: this.mediaNav,
      swipeAngle: false,
      speed: 400,
      nav: false,
      loop: false,
      autoPlay: false,
    });
  }

  mapTemplate(prop) {
    [...this.templateAll].map(template => {
      template.style.display = prop;
      if (prop === 'flex') {
        template.classList.add('template--flex');

        // for windows xp 
        this.mapTemplateItems(template);
      }
    })
  }

  mapTemplateItems(template) {
    [...template.children].map((item, i) => {
      this.removeItem(item);

      if (i === 0) {
        const itemChildElement = item.firstElementChild;
        const priorityNews = itemChildElement.classList.contains('item--news-day-large')
          || itemChildElement.classList.contains('item--news-day-large-no-img')
          || itemChildElement.classList.contains('banner--square-big');

        priorityNews && (
          this.createNewElement(item, template)
        )
      }
    })
  }

  createNewElement(item, template) {
    const createPriority = document.createElement('div');
    createPriority.setAttribute('class', 'full-row');
    createPriority.appendChild(item.firstElementChild);
    template.parentElement.insertBefore(createPriority, template)
    item.remove();
  }

  removeItem(item) {
    const itemChildElement = item.firstElementChild;
    (itemChildElement.classList.contains('news-feed') || itemChildElement.classList.contains('banner--rectangle-vertical'))
      && item.remove();
  }

  init() {

    if (this.mediaList) {
      this._tinySlider();
    }

    if (new DetectedBrowser().checkSupportGrid() && this.templateAll) {
      this.mapTemplate('grid');
    } else {
      this.mapTemplate('flex');
    }

  }
}
